// frontend/src/components/pages/home/HeaderSimple.jsx
import { useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import { LogoWithText } from "../../Logo";

const HeaderSimple = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (error) {}
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };

  // Get first letter of user's name
  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : "U";
  };

  return (
    <header
      className="fixed top-4 left-1/2 -translate-x-1/2 z-50
      bg-bg-70/90 dark:bg-bg-60/90 
      backdrop-blur-xl border border-bd-50 dark:border-bd-50
      rounded-full w-[90%] max-w-6xl px-6 py-2 pr-4 flex items-center justify-between shadow-md transition-all"
    >
      {/* Left: Logo */}
      <div className="flex items-center">
        <Link to="/" className="flex items-center">
          <LogoWithText
            className="h-7 w-auto max-w-32"
            fillClassName="fill-fg-40 hover:fill-fg-30 transition-colors"
          />
        </Link>
      </div>

      {/* Right: User Profile + Logout */}
      <div className="flex items-center gap-3">
        {user && (
          <div className="flex items-center gap-2 bg-bg-50 dark:bg-bg-40 px-3 py-1.5 rounded-full">
            {/* User Avatar & Name */}
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-ac-02 dark:bg-ac-02 flex items-center justify-center border border-bd-50 dark:border-bd-50">
                <span className="text-white dark:text-black text-sm font-semibold">
                  {getInitial(user.name)}
                </span>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-xs text-fg-60 dark:text-fg-60">Hi,</span>
                <span className="text-sm font-medium text-fg-40 dark:text-fg-40">
                  {user.name || "User"}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="p-2 rounded-full text-fg-60 hover:bg-bg-60 dark:hover:bg-bg-50 transition-colors"
          title="Logout"
          aria-label="Logout"
        >
          <LogOut size={18} />
        </button>
      </div>
    </header>
  );
};

export default HeaderSimple;
